<div class="input-group">
  <ng-container *appHideIfNotInRole="['vessels-delivery-note-editor']">
    <button
      mat-stroked-button
      type="button"
      id="addButtonGroup"
      aria-expanded="false"
      (click)="addBunker()"
    >
      Add
    </button>
  </ng-container>
</div>